import { ProcedureType, SampleType } from "@/services/backend/types";
import { ReactElement } from "react";
import { useParams } from "react-router";
import CountingTable from "@/shared/components/domain/counting/counting-table";
import { useShowDifferentiationQuery } from "@/services/backend/differentiation/service";

function CountingIndexRoute(): ReactElement {
  const { differentiationId } = useParams();
  const { data: differentiation } = useShowDifferentiationQuery({
    id: differentiationId!,
  });
  const immutable = !!differentiation?.differentiation.immutable;

  return (
    <div className="flex w-full flex-col">
      <div className="flex w-full flex-col space-y-4">
        <CountingTable
          label="Oberflächenkeimprobe - 1N-RLT"
          ownerId={differentiationId as string}
          ownerType="differentiation.Differentiation"
          procedureType={ProcedureType.RLT1N}
          sampleType={SampleType.SurfaceMicrobial}
          immutable={immutable}
        />

        <CountingTable
          label="Oberflächenkeimprobe - 2N-RLT"
          ownerId={differentiationId as string}
          ownerType="differentiation.Differentiation"
          procedureType={ProcedureType.RLT2N}
          sampleType={SampleType.SurfaceMicrobial}
          immutable={immutable}
        />

        <CountingTable
          label="Luftkeimprobe - 1N-RLT"
          ownerId={differentiationId as string}
          ownerType="differentiation.Differentiation"
          procedureType={ProcedureType.RLT1N}
          sampleType={SampleType.AirMicrobial}
          immutable={immutable}
        />

        <CountingTable
          label="Luftkeimprobe - 2N-RLT"
          ownerId={differentiationId as string}
          ownerType="differentiation.Differentiation"
          procedureType={ProcedureType.RLT2N}
          sampleType={SampleType.AirMicrobial}
          immutable={immutable}
        />
      </div>
    </div>
  );
}

export default CountingIndexRoute;
